import React, { PureComponent } from 'react'
import {connect} from "react-redux";


import * as actions from "../../store/actions/actions";
import Header from "../../components/Headers/Header";
import {Button, Card, CardBody, CardHeader, Container, FormGroup, Input, Row} from "reactstrap";
import Col from "react-bootstrap/Col";
import "./contoCorrente.css"
import { withLocalize } from "react-localize-redux";
import { Translate } from "react-localize-redux";

import italianContoCorrenteEditTranslations from "../../translations/contoCorrente/edit/it.contoCorrente.edit.json";
import englishContoCorrenteEditTranslations from "../../translations/contoCorrente/edit/en.contoCorrente.edit.json";

class ContoCorrenteEdit extends PureComponent {
  constructor(props) {
    super(props);

    this.props.addTranslationForLanguage(italianContoCorrenteEditTranslations, "it");
    this.props.addTranslationForLanguage(englishContoCorrenteEditTranslations, "en");
  }

  onBackClick = () => {
    this.props.history.goBack();
  }

  submitHandler = (event) => {
    event.preventDefault();
    let corporateId = '';
    let path = this.props.history.location.pathname
    if(path !== 'undefined' && path !== null) {
      corporateId = path.split("/")
    }
    let data = {
      id: this.props.contoCorrenteToEdit.id,
      contoCorrente: this.props.contoCorrenteToEdit.contoCorrente,
      senderAccount: this.props.contoCorrenteToEdit.senderAccount,
      note: this.props.contoCorrenteToEdit.note,
      enabled: this.props.contoCorrenteToEdit.enabled,
      corporate: corporateId[3],
      bankId:this.props.contoCorrenteToEdit.bankId
    }
    this.props.updatecontoCorrente(data)
  }

  onNoteChange = (event) => {
    let note = event.target.value
    this.props.noteChange(note)
  }

  onContoCorrenteChange = (event) => {
    let contoCorrente = event.target.value
    this.props.contoCorrenteChange(contoCorrente)
  }

  onSenderAccountChange = (event) => {
    let senderAccount = event.target.value
    this.props.senderAccountChange(senderAccount)
  }

  render() {

    let errors=""
    errors=this.props.validationError
    let contoCorrenteError=""
    let senderAccountError=""
    if(errors !== null && errors !== "" && errors !== undefined){
      if(errors.data.length>0){
        errors.data.map((item) =>{
          if(item.field ==='contoCorrente'){
            contoCorrenteError=item.defaultMessage;
          }
          if(item.field === 'senderAccount'){
            senderAccountError=item.defaultMessage
          }
          return ""
        })
      }
    }

    return (
        <>
          <Header />
          <Container className="mt--5" fluid>
            <Row>
              <div className="col" style={{paddingBottom:"2%"}}>
                <Card className="shadow">
                  <CardHeader className="border-0">
                    <Row>
                      <div className="col">
                        <h3 className="mb-0">
                          <Translate id="conto.corrente.edit.title" data={{ contoCorrente: this.props.contoCorrente }}/>
                        </h3>
                      </div>
                    </Row>
                  </CardHeader>
                  <CardBody>
                    <form onSubmit={this.submitHandler}>
                      <div className="pl-lg-4">
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="contoCorrente">
                                <Translate id="conto.corrente.edit.contoCorrente"/>
                              </label>
                              <Translate>
                                {({ translate }) =>
                                  <Input className={ contoCorrenteError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                     value={this.props.contoCorrente}
                                     onChange={this.onContoCorrenteChange}
                                     id="contoCorrente"
                                     placeholder={translate("conto.corrente.edit.contoCorrente")}
                                     type="text" />}
                              </Translate>
                            </FormGroup>
                            { contoCorrenteError.length > 0 ? <label style={{color:"red"}}><Translate id={contoCorrenteError}/></label> : "" }
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="senderAccount">
                                <Translate id="conto.corrente.edit.senderAccount"/>
                              </label>
                              <Translate>
                                {({ translate }) =>
                                  <Input className={ senderAccountError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                     onChange={this.onSenderAccountChange}
                                     value={this.props.senderAccount}
                                     id="senderAccount"
                                     placeholder={translate("conto.corrente.edit.senderAccount")}
                                     type="text" />}
                              </Translate>
                            </FormGroup>
                            { senderAccountError.length > 0 ? <label style={{color:"red"}}><Translate id={senderAccountError}/></label> : "" }
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="note">
                                <Translate id="conto.corrente.edit.note"/>
                              </label>
                              <Translate>
                                {({ translate }) =>
                                  <Input className="form-control-alternative"
                                     onChange={this.onNoteChange}
                                     id="note"
                                     value={this.props.note}
                                     placeholder={translate("conto.corrente.create.note")}
                                     type="text" />}
                              </Translate>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col align="left">
                            <Button onClick={this.onBackClick} variant="contained">
                              <i className="fas fa-arrow-left text-primary" />
                            </Button>
                          </Col>
                          <Col align="right">
                            <Button  type="submit" className="btn-success" variant="contained" >
                              <Translate id="conto.corrente.edit.update.button" data={{ contoCorrente: this.props.contoCorrente }}/>
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    </form>
                  </CardBody>
                </Card>
              </div>
            </Row>
          </Container>
        </>
    );
  }
}

const mapStateToProps = state => {
  return {
    contoCorrenteToEdit: state.contoCorrenteEdit.contoCorrenteToEdit,
    note: state.contoCorrenteEdit.contoCorrenteToEdit.note,
    senderAccount: state.contoCorrenteEdit.contoCorrenteToEdit.senderAccount,
    contoCorrente: state.contoCorrenteEdit.contoCorrenteToEdit.contoCorrente,
    validationError: state.contoCorrenteEdit.error,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updatecontoCorrente: (contoCorrente) => dispatch({ type: actions.UPDATE_CONTO_CORRENTE_EDIT_REQUEST, value: {contoCorrente:contoCorrente,bankId:contoCorrente.bankId} }),
    noteChange: (note) => dispatch({ type: actions.EDIT_CONTO_CORRENTE_NOTE_FILED_CHANGE_REQUEST, value: note }),
    contoCorrenteChange: (contoCorrente) => dispatch({ type: actions.EDIT_CONTO_CORRENTE_CONTO_CORRENTE_FILED_CHANGE_REQUEST, value: contoCorrente }),
    senderAccountChange: (senderAccount) => dispatch({ type: actions.EDIT_CONTO_CORRENTE_SENDER_ACCOUNT_FILED_CHANGE_REQUEST, value: senderAccount }),
  }
}

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(ContoCorrenteEdit));